import { IValidationUploadStatsData } from "common/records/ValidationUploadStats";
import { IValidationData } from "common/records/Validation";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_STATS = "@validation/RECEIVE_STATS";
export const RECEIVE_VALIDATIONS = "@validation/RECEIVE_VALIDATIONS";

export const ValidationActions = {
  receiveStats: (stats: IValidationUploadStatsData) => createAction(RECEIVE_STATS, { stats: stats }),
  receiveValidations: (validations: IValidationData[]) => createAction(RECEIVE_VALIDATIONS, { validations }),
};

export type ValidationActions = ActionsUnion<typeof ValidationActions>;
